import axios from 'axios'
import { message } from 'ant-design-vue';
import { getApiBaseUrl } from '@/utils/env'
const apiBaseUrl = getApiBaseUrl()
// 创建 Axios 实例
const myAxios = axios.create({
  baseURL: apiBaseUrl,
  timeout: 3000000,
  withCredentials: true,
}) 
 
// 添加请求拦截器
myAxios.interceptors.request.use(config => {
  // 在发送请求之前做些什么，例如设置 token
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => { 
      if(error.status==400){
        message.error(error.response.data.errMsg) 
        
      } 
      return error; 
});

import FileHandler from "../utils/fileHandler";
// 全局响应拦截器
myAxios.interceptors.response.use( 
  function (response) { 
    // 检查是否有新的 Token，如果有则更新
    const newToken = response.headers['newtoken'];
    if (newToken) {
      localStorage.setItem('token', newToken);
      console.log('New token:', newToken);
    }

    // 调用方显式要求跳过自动下载（例如把 docx 直接交给编辑器渲染）
    if (response.config && response.config.skipFileHandler) {
      return response.data;
    }

    // 判断是否为文件下载响应
    const contentType = response.headers['content-type'];
    if (contentType && (contentType.indexOf('application/octet-stream') !== -1 || 
                        contentType.indexOf('application/force-download') !== -1 ||
                        contentType.indexOf('application/vnd.ms-excel') !== -1 ||
                        contentType.indexOf('application/vnd.openxmlformats-officedocument') !== -1 ||
                        contentType.indexOf('application/pdf') !== -1)) {
      // 文件下载响应，直接返回
      return FileHandler.responsedownload(response);
    }

    try { 
      const { data } = response
      // 未登录
      if (data.code === 401) {
        // 清理 localStorage 中的用户相关信息
        localStorage.removeItem('user');
        localStorage.removeItem('UserPermissions');
        localStorage.removeItem('token');
        
        // 不是获取用户信息的请求，并且用户目前不是已经在用户登录页面，则跳转到登录页面
        if (
          !response.request.responseURL.includes('user/get/login') &&
          !window.location.pathname.includes('/login') &&
          !window.location.pathname.includes('/NumberLogin')
        ) {
          message.error('请先登录')
          window.location.href = `/NumberLogin?redirect=${window.location.href}`
        }
      }
      if(data.code==400){ 
        // 兼容 errMsg / err_msg（后端字段不统一）
        const errText = data.errMsg ?? data.err_msg
        console.log(errText)    
        message.error(errText) 
        return Promise.reject(new Error(errText)) 
      }
      return response.data;
    } catch (error) { 
      if(error.status==400||error.status==500){
        message.error(error.response.data.err_msg) 
        return Promise.reject(new Error(error.response.data.err_msg)) 
      } 
     if (error.status === 401) {
        // 清理 localStorage 中的用户相关信息
        localStorage.removeItem('user');
        localStorage.removeItem('UserPermissions');
        localStorage.removeItem('token');
        
        // 不是获取用户信息的请求，并且用户目前不是已经在用户登录页面，则跳转到登录页面
        if (
          !response.request.responseURL.includes('user/get/login') &&
          !window.location.pathname.includes('/login') &&
          !window.location.pathname.includes('/NumberLogin')
        ) {
          message.error('请先登录')
          window.location.href = `/NumberLogin?redirect=${window.location.href}`
        }
      }
      if(error.status==403){
      message.error('接口无权限访问')  
      return Promise.reject(new Error(error.response.data.err_msg)) 
    }  
      return error; 
    }
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error  
    console.log(error)
    // 仅做兼容：优先 response.status；文案兼容 errMsg / err_msg（不改变原有分支逻辑）
    const status = error.response?.status ?? error.status;
    const data = error.response?.data || {};
    const errText = data.errMsg ?? data.err_msg;
    if(status==400||status==500){
      message.error(errText)  
      return Promise.reject(new Error(errText)) 
    }  
    if(status==403){
      message.error('接口无权限访问')  
      return Promise.reject(new Error(errText)) 
    }  
    if (status === 401) {
        // 清理 localStorage 中的用户相关信息
        localStorage.removeItem('user');
        localStorage.removeItem('UserPermissions');
        localStorage.removeItem('token'); 
        // 不是获取用户信息的请求，并且用户目前不是已经在用户登录页面，则跳转到登录页面
         message.error('请先登录')
          window.location.href = `/NumberLogin?redirect=${window.location.href}`
      }
    return Promise.reject(new Error(error)) 
  }
);

export default myAxios;
